function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorsRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "765px",
    height: "755px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededee",
    d: "M 42.5,-0.5 C 135.5,-0.5 228.5,-0.5 321.5,-0.5C 354.43,14.0152 368.597,39.3486 364,75.5C 365.208,158.195 364.208,240.862 361,323.5C 352.948,342.295 339.114,354.795 319.5,361C 227.167,363 134.833,363 42.5,361C 25.0245,355.193 12.1912,344.026 4,327.5C 1.65131,278.371 0.15131,229.371 -0.5,180.5C -0.5,159.5 -0.5,138.5 -0.5,117.5C 0.06736,91.9723 0.900693,66.3056 2,40.5C 9.71169,20.9558 23.2117,7.28913 42.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0eded",
    d: "M 494.5,-0.5 C 512.5,-0.5 530.5,-0.5 548.5,-0.5C 605.01,0.0891321 661.677,0.922465 718.5,2C 750.588,12.7006 765.921,34.8673 764.5,68.5C 764.5,144.167 764.5,219.833 764.5,295.5C 765.196,331.511 747.863,354.011 712.5,363C 626.5,364.996 540.5,364.996 454.5,363C 424.996,357.496 407.496,339.996 402,310.5C 400,224.5 400,138.5 402,52.5C 407.963,27.2035 423.13,10.0369 447.5,1C 463.339,0.831398 479.005,0.331398 494.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee4544",
    d: "M 49.5,39.5 C 136.834,39.3333 224.167,39.5 311.5,40C 317.583,42.4148 322.083,46.5815 325,52.5C 325.667,137.5 325.667,222.5 325,307.5C 321.768,312.788 317.935,317.622 313.5,322C 229.186,323.639 144.853,323.972 60.5,323C 57.1667,322.667 53.8333,322.333 50.5,322C 46.6311,318.466 43.1311,314.633 40,310.5C 38,224.167 38,137.833 40,51.5C 42.6193,47.0496 45.7859,43.0496 49.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef4544",
    d: "M 455.5,39.5 C 540.501,39.3333 625.501,39.5 710.5,40C 716.289,43.4547 721.122,47.9547 725,53.5C 725.916,139.508 725.582,225.508 724,311.5C 721.167,315.667 717.667,319.167 713.5,322C 626.83,323.913 540.163,323.913 453.5,322C 449.333,319.167 445.833,315.667 443,311.5C 441.038,224.832 441.038,138.166 443,51.5C 447.062,47.2688 451.229,43.2688 455.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeded",
    d: "M -0.5,636.5 C -0.5,615.5 -0.5,594.5 -0.5,573.5C 0.332861,527.655 1.49953,481.655 3,435.5C 3.33333,432.5 3.66667,429.5 4,426.5C 13.0739,408.099 27.5739,396.266 47.5,391C 137.167,389.004 226.833,389.004 316.5,391C 340.459,396.958 355.959,411.792 363,435.5C 364.996,526.167 364.996,616.833 363,707.5C 357.634,729.868 344.134,745.035 322.5,753C 228.5,753.667 134.5,753.667 40.5,753C 21.9111,745.412 9.07781,732.245 2,713.5C 0.900693,687.694 0.06736,662.028 -0.5,636.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeceb",
    d: "M 764.5,511.5 C 764.5,573.833 764.5,636.167 764.5,698.5C 763.556,712.743 758.39,725.409 749,736.5C 739.854,742.648 730.687,748.648 721.5,754.5C 629.5,754.5 537.5,754.5 445.5,754.5C 421.681,745.572 407.181,728.572 402,703.5C 400.912,659.843 400.412,616.177 400.5,572.5C 400.406,529.489 400.906,486.489 402,443.5C 407.881,417.286 423.715,400.453 449.5,393C 493.828,392.041 538.161,391.541 582.5,391.5C 628.554,391.228 674.554,392.061 720.5,394C 739.296,399.796 752.796,411.629 761,429.5C 762.417,456.98 763.584,484.314 764.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef4544",
    d: "M 52.5,428.5 C 137.834,428.333 223.167,428.5 308.5,429C 315.881,431.716 321.381,436.549 325,443.5C 325.925,529.175 325.592,614.842 324,700.5C 320.917,705.588 317.083,710.088 312.5,714C 225.5,715.996 138.5,715.996 51.5,714C 46.3333,711.5 42.5,707.667 40,702.5C 38.0035,616.167 38.0035,529.833 40,443.5C 43.6247,438.043 47.7913,433.043 52.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee4544",
    d: "M 451.5,430.5 C 539.833,430.942 628.167,431.442 716.5,432C 721.915,435.074 725.415,439.574 727,445.5C 727.667,530.5 727.667,615.5 727,700.5C 725.393,706.105 722.226,710.605 717.5,714C 690.348,714.288 663.348,715.288 636.5,717C 608.667,717.167 580.833,717.333 553,717.5C 519.818,717.603 486.652,717.103 453.5,716C 447.333,713.167 442.833,708.667 440,702.5C 439.333,616.167 439.333,529.833 440,443.5C 442.984,438.353 446.818,434.02 451.5,430.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsRed);
export default __webpack_public_path__ + "static/media/colors_red.0bfc1aa2e0c7eaeb87bffe5dd3f11fa6.svg";
export { ForwardRef as ReactComponent };